export const ORIENTATION = {
  VERTICAL: 'vertical',
  HORIZONTAL: 'horizontal',
} as const;

export const INDICATOR_FIXED_DIMENSION_SIZE = '2px';

export enum Layout {
  STRETCH = 'stretch',
  INLINE = 'inline',
  FIXED = 'fixed'
}
